<template>
  <div class="activities-setting-selector">
    <span class="activity-title">选择活动</span>
    <draggable v-if="Array.isArray($$FormData.activities)" v-bind="{ sort: true }" :list="$$FormData.activities"
      prevent-on-filter animation="200" filter=".ignore-drag" class="activity-list">
      <transition-group>
        <div v-for="item in $$FormData.activities" :key="item.goods_id" class="item-activity">
          <img :src="item.thumbnail" :alt="item.goods_name" class="activity-img" />
          <i class="ri-close-circle-fill del-icon" @click="handleDeleteActivity(item)"></i>
        </div>
        <div class="item-activity add ignore-drag" key="add-goods" @click="handleAddActivity">
          <i class="ri-add-line"></i>
        </div>
      </transition-group>
    </draggable>
    <en-book-activities-picker
      :show="picker_show"
      :request="$$Request"
      :default-ids="selectedIds"
      @confirm="handleActivityPickerConfirm"
      @closed="picker_show = false"
    />
  </div>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  name: 'ActivitiesSelector',
  components: { Draggable },
  data() {
    return {
      picker_show: false
    }
  },
  computed: {
    selectedIds() {
      const activities = this.$$FormData.activities || []
      return activities.map(item => item.goods_id)
    }
  },
  methods: {
    handleAddActivity() {
      this.picker_show = true
    },
    handleDeleteActivity(item) {
      const index = this.$$FormData.activities.findIndex(_item => _item.goods_id === item.goods_id)
      this.$$FormData.activities.splice(index, 1)
    },
    handleActivityPickerConfirm(items) {
      items = JSON.parse(JSON.stringify(items))
      this.$$FormData.activities = items.map(item => ({
        author: item.author,
        goods_id: item.goods_id,
        goods_name: item.goods_name,
        thumbnail: item.thumbnail,
        activity_area: item.activity_area,
        activity_time: item.activity_time,
        price: item.price,
        seller_id: item.seller_id,
        seller_name: item.seller_name,
        publish_date: item.publish_date,
        market_enable: item.market_enable
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.activities-setting-selector {
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  background-color: #ffffff;

  .activity-title {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #969799;
    line-height: 18px;
    white-space: nowrap;
  }

  .activity-list {
    padding: 12px 16px;
    background-color: #f7f8fa;
    box-sizing: border-box;

    &>span {
      display: flex;
      flex-wrap: wrap;
    }

    .item-activity {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      padding: 0;
      margin: 5px 10px 5px 0;
      border: none;
      box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
      color: #155bd4;
      font-size: 14px;
      background-color: #ffffff;
      border-radius: 2px;
      cursor: move;

      &.add {
        cursor: pointer;
      }

      &:hover {
        .del-icon {
          display: block;
        }

        &:not(.add)::after {
          display: block;
        }
      }

      &::after {
        display: none;
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #155bd4;
        border-radius: 2px;
        z-index: 1;
        pointer-events: none;
      }

      .activity-img {
        display: block;
        width: 100%;
        height: 100%;
        margin: 0;
        overflow: hidden;
      }

      .del-icon {
        display: none;
        position: absolute;
        z-index: 2;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        color: #bbbbbb;
        font-size: 20px;
        background-color: #ffffff;
        line-height: normal;
        cursor: pointer;
      }
    }
  }
}
</style>
